import { atom } from "recoil";

export const playerBanEditModalStore = atom({
	key: "playerBanEditModalStore",
	default: {
		show: false,
		loaded: false,
		uid: false,
		reason: "",
		banType: false,
		date: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
